import { render, staticRenderFns } from "./node-properties.vue?vue&type=template&id=901c6454"
import script from "./node-properties.vue?vue&type=script&lang=js"
export * from "./node-properties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports